import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import moment from 'moment';

import {
	changeCurrentPath,
	fetchShipmentDetail,
	resetShipmentDetailState,
	resetShipmentState,
	getPdfItemsShipment,
	saveShipmentDetail,
	clearPdfItemsShipment,
	setShipmentState
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/editable-table';
import AlertDialog from '../../common/components/dialog/alert-dialog';
import PdfViewer from '../../common/components/viewer/pdf-viewer';
import {COL_TYPE} from "../../common/utils/tables";
import {resetEditableTableState} from "../../actions/components";
import {isSameObject} from "../../common/utils/array";



const columns = [
	{ name: 'HaisoNO', title: '配送順' ,width:100,type:COL_TYPE.EDIT_NULLABLE_NUM},
	{ name: 'NinushiTorihikiName', title: '取引名称' ,width:130},
	{ name: 'OtodokesakiName', title: '納品先名称' ,width:250},
	{ name: 'OtodokesakiAddress', title: '納品先住所' ,width:250},
	{ name: 'NinushiName', title: '荷主名' ,width:250},
	{ name: 'DenpyoNO', title: '伝票番号' ,width:150,type:COL_TYPE.CLICK_TEXT},
	{ name: 'Yobi1', title: '予備項目1' ,width:200},
	{ name: 'TorikomiDateTime', title: '取込時刻' ,width:150},
];


const styles = theme => ({
	datePicker : {
		marginTop : '-10px',
		width:'150px'
	},
	fromTo : {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
	},
	expands : {
		boxShadow:'initial',
	},
	extractWrap:{
		display:'flex',
		flexDirection:'row',
		marginBottom:15
	},
	extractValues:{
		marginRight:15,
		'& > span':{
			backgroundColor:'rgba(0,0,0,0.05)',
			padding:'5px 10px',
			borderRadius:5

		}
	}

});

class ShipmentDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dialogOpen:false,
			cancelDialogOpen:false,
			forceUpdateController : 0
        }
		this.nextIsMainMenu = false;
        columns[_.findIndex(columns,{'name':'DenpyoNO'})]["func"] = this.handleClickSlipNo;

		const { dispatch, listSettings, auth} = props;

		const HeaderIDs = listSettings.selections.map((row)=>{
			return row.id
		});
		dispatch(fetchShipmentDetail({
			SessionID:auth.SessionID,
			HeaderIDs
		}));
    }
    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	componentWillUnmount(){
		const {dispatch} = this.props;
		dispatch(resetShipmentDetailState());
		dispatch(resetEditableTableState());
		if(!this.nextIsMainMenu) {
			//TABLE STATEをリセット
			dispatch(resetShipmentState());
		}
	}
	componentDidUpdate(prevProps, prevState, snapshot) {
		const {settings,history,dispatch} = this.props;
		if(settings.isCompleteSaveDetails) {
			dispatch(setShipmentState({
				isDetailsUpdate: true
			}))
			history.push('/shipment');
		}
	}


	/** event handlers **/
	handleClickBack = event => {

		if(!this.checkIsUpdate()){
			this.doCancel();
			return;
		}

		const { dispatch, tableState, settings } = this.props;
		const SessionID = this.props.auth.SessionID;

		//　ワークテーブルに保存するデータの作成
		const saveTarget = settings.data.map(original => {
			let data = {}
			const edited = tableState.rows.find(e=>e.id === original.id)
			// 元が未選択で操作によって選択された時
			if(original.isSelected === false && tableState.selection.findIndex(e => e===original.id) > -1) {
				data.id = original.id;
				data.isSelected = true;
				data.isUpdate = true;
			}
			//　元が選択済で、操作によって未選択になった時
			if(original.isSelected === true && tableState.selection.findIndex(e => e===original.id) === -1) {
				data.id = original.id;
				data.isSelected = false;
				data.HaisoNO = null;
				data.isUpdate = true;
			}
			//配送順が変更されている場合
			if(original.HaisoNO !== edited.HaisoNO) {
				data.id = original.id;
				data.HaisoNO = edited.HaisoNO;
				data.isSelected = !(data.isSelected) ? null : data.isSelected;
				data.isUpdate = true;
			}
			return data;
		}).filter(e=>Object.keys(e).length > 0)
		this.nextIsMainMenu = true;

		dispatch(saveShipmentDetail({
			jsonString:JSON.stringify(saveTarget),
			SessionID: SessionID
		}));
	};

	handleClickSlipNo = (id) =>{
		const {dispatch,auth} = this.props;
	 	const selections = [id];
	 	dispatch(getPdfItemsShipment({
	 		selections,
	 		SessionID:auth.SessionID
	 	}));
	};
	afterCloseFunc = () => {
		const { dispatch} = this.props;
		dispatch(clearPdfItemsShipment());
	};
	handleClickCancel = () =>{
		if(this.checkIsUpdate()) {
			this.setState({
				cancelDialogOpen: true
			})
		} else {
			this.nextIsMainMenu = true;
			this.props.history.push('/shipment');
		}
	}
	handleDoCancel = () =>{
		this.setState({
			cancelDialogOpen:false
		})
		this.doCancel();
	}
	handleCancelCancel = () =>{
		this.setState({
			cancelDialogOpen:false
		})
	}
	doCancel = () =>{
		this.nextIsMainMenu = true;
		this.props.history.push('/shipment');
	}
	handleAfterChangeFunc = (updateRow, tableState) =>{
		// 配送順の判定のみ行う
		const id = updateRow.id;
		const originalData = this.props.settings.data.find(e=>(e.id===id));
		updateRow.isRowUpdate = String(originalData.HaisoNO) !== String(updateRow.HaisoNO);


		return updateRow;
	};

	checkIsUpdate = () =>{
		const {tableState,settings} = this.props;
		const {rows,selection} = tableState;

		const isRowValueUpdate = Boolean(_.filter(rows,"isRowUpdate").length > 0);
		const originalSelections = _.filter(settings.data,"isSelected").map(row=>{return row.id});
		const isSelectionUpdate = !isSameObject(originalSelections.sort(),selection.sort());
		return isRowValueUpdate || isSelectionUpdate;
	}

	render() {
		const {settings,listSettings,history,classes} = this.props;
		const {cancelDialogOpen} = this.state;

		const {deliveryDate,inputCarNumber,inputRotationNO} = listSettings;

		const deliveryDateString = moment(deliveryDate).format('YYYY/MM/DD');
		const extractRotationNoString = !(inputRotationNO)? "指定なし" : inputRotationNO;

		let mainButtons = [
			{type:'SAVE',func:this.handleClickBack,text:"確定"},
			{type:'CLEAR',func:this.handleClickCancel,text:"キャンセル"},
		];

		const printDialogOpen = (settings.pdfPath !== undefined);


		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={history}/>
				<Header history={history}/>
				<article>
					<section className="title_area">
						<h2>車番登録<span>明細</span></h2>
					</section>
					<section className="with_button">
						<div className={classes.extractWrap}>
							<p
								className={classes.extractValues}
							><span>納品日</span> {deliveryDateString}</p>
							<p
								className={classes.extractValues}
							><span>車番</span> {inputCarNumber}</p>
							<p
								className={classes.extractValues}
							><span>回転</span> {extractRotationNoString}</p>
						</div>
						<Tables
							dataSource={settings.data}
							columns={columns}
							defaultSorts={[{columnName:'HaisoNO',direction:'asc'}]}
							isDefaultAllChecked={true}
							onAfterUpdateRow={this.handleAfterChangeFunc}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<AlertDialog
					open={cancelDialogOpen}
					title={"確認"}
					text={<span>編集中のデータは破棄されます。<br/>よろしいですか？</span>}
					okFunction={this.handleDoCancel}
					closeFunction={this.handleCancelCancel}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.shipmentDetailSettings,
		listSettings : state.shipmentSettings,
		tableState : state.componentsEditableTableState,
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(ShipmentDetail);



// WEBPACK FOOTER //
// ./src/routes/shipment-detail/index.js